import { useAuth } from "@/hooks/useAuth";
import { loadUserPermissions } from "@/stores/slice/permissionSlice";
import React, { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { Navigate } from 'react-router-dom';

const SuperAdminGuard = ({ children }) => {
  const { authenticated, role } = useAuth();
  const userId = localStorage.getItem("user_id");

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadUserPermissions(userId))
  }, [userId])
  if (!authenticated) {
    return <Navigate to="/login" />;
  }
  if (role !== 'SUPERADMIN') {
    return <Navigate to="/superadmin/restricted-access" />;
  }

  return children;

};

export default SuperAdminGuard;
